import { useTranslation } from "react-i18next";
import type { ClientConfiguration as ClientConfigurationType } from "../../../../../types/clientConfig";
import { ClientConfigurationTemplateCard } from "./ClientConfigurationTemplateCard";

const sortByCreatedDate = (
  a: ClientConfigurationType,
  b: ClientConfigurationType
) =>
  (a.createdAt || "").localeCompare(b.createdAt || "", undefined, {
    sensitivity: "base",
  });

const sortByTitle = (a: ClientConfigurationType, b: ClientConfigurationType) =>
  (a.templateName || "").localeCompare(b.templateName || "", undefined, {
    sensitivity: "base",
  });
const sortByTitleDesc = (
  a: ClientConfigurationType,
  b: ClientConfigurationType
) =>
  (b.templateName || "").localeCompare(a.templateName || "", undefined, {
    sensitivity: "base",
  });

const SORT_FUNCTIONS = {
  createdDate: sortByCreatedDate,
  name: sortByTitle,
  nameDescending: sortByTitleDesc,
};

export const ClientConfigurationTemplates = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const {
    clientConfigurationTemplates = [],
    activeUserToRequest,
    query = {},
  }: {
    clientConfigurationTemplates: ClientConfigurationType[];
    activeUserToRequest?: { _id?: string; referAsClients?: boolean };
    query: { sort?: string };
  } = locals || {};

  // default is actually coming from controller as createdDate
  const sort = query.sort ?? "name";
  const sortFn = SORT_FUNCTIONS[sort] || sortByTitle;

  const coachId = String(activeUserToRequest?._id ?? "");
  const visibleTemplates = clientConfigurationTemplates.filter(
    (t) => t.templateType === "coach" && String(t.ownerId ?? "") === coachId
  );
  const sortedTemplates = [...visibleTemplates].sort(sortFn);

  const mobileUpdateNotice = (
    <div
      className="chip warning client-configuration-mobile-notice"
      role="alert"
    >
      <div className="chip-text">
        <span>
          <strong>
            {t(
              "allTemplates.clientConfigurationTemplates.mobileUpdateNoticeLabel"
            )}
          </strong>{" "}
          {t(
            "allTemplates.clientConfigurationTemplates.mobileUpdateNoticeText"
          )}
        </span>
      </div>
    </div>
  );

  if (!visibleTemplates.length) {
    return (
      <div className="no-programs-section client-configuration-templates">
        {mobileUpdateNotice}
        <p>{t("allTemplates.clientConfigurationTemplates.noTemplatesAdded")}</p>
      </div>
    );
  }

  return (
    <section className="generic-template-section client-configuration-templates">
      {mobileUpdateNotice}
      <div className="generic-template-grid">
        {sortedTemplates.map((template) => (
          <ClientConfigurationTemplateCard
            key={template._id}
            template={template}
            referAsClients={activeUserToRequest?.referAsClients ?? false}
          />
        ))}
      </div>
    </section>
  );
};
